import { css } from '@emotion/css';
// import verfiyBoxImg from '../../../assets/data_bg.png';

export const photoSm = css`
  width: 25px;
  border-radius: 50%;
`;

export const grabBox = css`
  padding: 16px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 8px;
  background: #00acf0;
`;

export const grabName = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.75;
  letter-spacing: 0.16px;
  color: #ffffff;
  text-transform: uppercase;
`;

export const loanTxt2 = css`
  font-size: 10px;
  text-align: left;
  color: #858585;
  padding-left: 20px;
`;
export const verifyBox = css`
  margin: auto;
  width: 328px;
  background-repeat: no-repeat;
  background-position: center;
`;
export const verifyHead = css`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.07;
  text-align: left;
  color: #ffffff;
  padding: 40px 2px 0px 20px;
`;
export const verifyContent = css`
  font-size: 12px;
  line-height: 1.33;
  text-align: left;
  color: #ffffff;
  padding: 10px 10px 0px 20px;
`;

export const verifyBox1MuiTableCellRoot = css`
  border-bottom: 0px !important;
`;

export const verifySkip = css`
  font-size: 12px;
  font-weight: 600;
  line-height: 1.42;
  text-align: left;
  color: #ffffff;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
`;

export const privyDoneTitle = css`
  font-size: 14px !important;
  font-weight: bold;
  line-height: 1.07;
  text-align: left;
  color: #ffffff !important;
  padding-right: 20px !important;
`;

export const privyDoneContent = css`
  font-size: 10px !important;
  font-size: 10px;
  line-height: 1.2;
  text-align: left;
  color: #ffffff !important;
  padding: 10px 20px 15px 0px !important;
`;

export const centerAlignHomeDiv = css`
  margin: 0 auto;
  width: 100%;
  padding: 24px 16px;
`;

export const centerAlignOfferDiv = css`
  margin: 0 auto;
  width: 100%;
  padding: 15px;

  @media screen and (min-width: 600px) {
    width: 70%;
  }
`;

export const infoCardBox = (backgroundUrl: string) => css`
  background-repeat: no-repeat;
  background-position: center;
  background-image: url(${backgroundUrl});
  display: grid !important;
  background-size: cover;
  border-radius: 8px;
  margin-top: 16px;
  padding: 16px;

  button {
    width: 100%;
  }
`;

export const infoCardBoxMuiTableCellRoot = css`
  border-bottom: 0px !important;
`;

export const infoCardHead1 = (color: string) => css`
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
  color: ${color};
  margin-bottom: 8px;
`;

export const infoCardContent1 = (color: string) => css`
  font-size: 12px;
  line-height: 1.33;
  text-align: left;
  color: ${color};

  .info-description {
    margin-bottom: 16px;

    p {
      margin-bottom: 16px;
    }
  }
`;

export const selectedLoanCss = css`
  border-radius: 8px;
  padding: 16px;
  background: #fff;
  margin-bottom: 16px;

  h3 {
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    color: #181818;
    margin-bottom: 8px;
  }

  .loan-detail-wrapper {
    display: flex;
    justify-content: space-between;
  }

  .caption {
    font-size: 10px;
    line-height: 15px;
    color: #616161;
  }

  .loan-amount {
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    color: #00acf0;
  }

  .loan-tenure {
    font-size: 14px;
    font-weight: 700;
    line-height: 22px;
    color: #616161;
  }
`;

export const infoCardHead2 = (color: string) => css`
  font-size: 14px !important;
  font-weight: bold;
  line-height: 1.07;
  text-align: left;
  color: ${color || '#ffffff'} !important;
  padding-right: 20px !important;
`;

export const infoCardContent2 = (color: string) => css`
  font-size: 10px !important;
  font-size: 10px;
  line-height: 1.2;
  text-align: left;
  color: ${color || '#ffffff'} !important;
  padding-top: 5px !important;
  padding-bottom: 10px !important;
`;

export const failoverAcceptedHeading = css`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  color: #00acf0;
`;

export const failoverAcceptedContent = css`
  opacity: 0.85;
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
  color: #5e5e5e;
`;

export const centerAlignPhotoDiv = css`
  margin: auto;
  width: 100%;

  @media screen and (min-width: 600px) {
    width: 60%;
  }
`;

export const photoUploadHeader = css`
  font-size: 14px;
  font-weight: bold;
  line-height: 1.36;
  text-align: center;
  color: #5e5e5e;
`;

export const photoUploadContent = css`
  font-size: 10px;
  line-height: 1.4;
  text-align: left;
  color: #00acf0;
`;

export const photoUploadLabel = css`
  font-size: 14px;
  line-height: 1.36;
  text-align: left;
  color: #5e5e5e;
`;

export const photoUploadLabel1 = css`
  font-size: 16px;
  line-height: 1.38;
  text-align: left;
  color: #ffffff;
`;

export const photoUploadLabel2 = css`
  font-size: 14px;
  line-height: 1.33;
  text-align: left;
  color: #5e5e5e;
`;

export const photoUploadFooter = css`
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  text-align: center;
  font-size: 9px;
`;

export const activeAccountDialog = css`
  text-align: center;
`;

export const activeAccountContent = css`
  font-size: 12px;
  line-height: 1.33;
  text-align: center;
  color: #5e5e5e;
  padding-bottom: 20px;
`;

export const buttonLabel = css`
  .activateAccountDialog,
  .cngPh {
    text-transform: none !important;
  }
`;

export const succeesPinHeading = css`
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  text-align: center;
  color: #00acf0;
`;

export const bankConfirmHead = css`
  font-size: 14px;
  line-height: 1.71;
  text-align: center;
  color: #5e5e5e;
`;

export const paymentDialogTxtMuiButtonOutlinedPrimary = css`
  color: #00acf0;
  border: 1px solid #00acf0;
`;

export const commonMsg = css`
  white-space: pre-wrap;
`;

export const infoCardContainer = css`
  button {
    width: 100%;
  }
`;

export const bottomSheeetContainer = css`
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  padding: 12px 16px 28px 16px;
  margin: auto;
  max-width: 550px;

  img {
    display: block;
    width: 100%;
    height: auto;
    margin-bottom: 16px;
    border-radius: 8px;
  }

  hr {
    width: 100%;
    border: 0.5px solid #ededed;
    margin: 16px 0px;
  }

  h3 {
    color: #181818;
    font-size: 16px;
    font-weight: 700;
    line-height: 24px;
    margin: 0;
  }

  p {
    font-size: 14px;
    line-height: 22px;
    color: #404040;
    margin-bottom: 16px;
    text-align: center;
  }

  div.ticker {
    padding: 8px 12px;
    border-radius: 8px;
    background: #ededed;
    margin-bottom: 12px;
    display: flex;
    align-items: center;

    p.body {
      font-size: 14px;
      line-height: 22px;
      color: #404040;
      margin-bottom: 16px;
      text-align: center;
    }

    p.caption {
      font-weight: 400;
      font-size: var(--fontSizes-captionRegular);
      line-height: var(--lineHeights-captionRegular);
      margin: 0;
    }

    svg {
      margin-right: 8px;
    }
  }

  a.link {
    font-weight: bold;
    color: #00acf0;
    text-decoration: none;
    margin-left: 4px;
  }
`;

export const updateEmergencyContactCard = css`
  margin-top: 1rem;

  .julo-card {
    padding: 0;
    overflow: hidden;
    border-color: var(--colors-primary-10);

    .julo-card__body {
      gap: 1rem;
      padding: 0;
      display: flex;
      justify-content: space-between;
      background: linear-gradient(
        180deg,
        rgba(255, 252, 252, 0.2) 26.25%,
        rgba(0, 172, 240, 0.2) 171.25%
      );

      .copy {
        flex: 1;
        display: flex;
        padding: 0.5rem;
        flex-direction: column;
        color: var(--colors-primary-50);

        .julo-button {
          padding: 0.5rem;
          font-size: 10px;
          margin-top: 0.5rem;
        }
      }
    }
  }
`;
